/*
 * useProductHooks.js
 *
 * Speakers
 * Created by Mahdi Yousefpour on Sat Feb 04 2023 mys Company
 */

import { useMutation } from '@tanstack/react-query'
import { axiosInstance, Methods } from '../../../config/axios/Axios'

export const useProductHooks = () => {
    let version = 'v1'
    let name = 'product'

    const { mutate: get } = useMutation({
        mutationFn: async (params) => {
            let queryStrings = '?pi=' + (params?.pi ?? 0) + '&ps=' + (params?.ps ?? 20) + '&order=' + (params?.order ?? 'desc') + '&field=' + (params?.field ?? 'id')
            const response = await axiosInstance(version, name + queryStrings, null, Methods.GET, {}, {})
            return response
        },
    })

    const { mutate: getOne } = useMutation({
        mutationFn: async (id) => {
            const response = await axiosInstance(version, name + '/' + id, null, Methods.GET, {}, {})
            return response
        },
    })

    const { mutate: search } = useMutation({
        mutationFn: async (params) => {
            let queryStrings = '?pi=' + (params?.pi ?? 0) + '&ps=' + (params?.ps ?? 20) + '&order=' + (params?.order ?? 'desc') + '&field=' + (params?.field ?? 'id')
            const response = await axiosInstance(version, name + '/search/' + params.query + queryStrings, null, Methods.GET, {}, {})
            return response
        },
    })

    const { mutate: post } = useMutation({
        mutationFn: async (model) => {
            const response = await axiosInstance(version, name, null, Methods.POST, {}, { model })
            return response
        },
    })

    const { mutate: put } = useMutation({
        mutationFn: async (model) => {
            const response = await axiosInstance(version, name, null, Methods.PUT, {}, { model })
            return response
        },
    })

    const { mutate: deleted } = useMutation({
        mutationFn: async (id) => {
            const response = await axiosInstance(version, name + '/' + id, null, Methods.DELETE, {}, null)
            return response
        },
    })

    return { get, getOne, search, post, put, deleted }
}
